
import React from 'react';
import { Helmet } from 'react-helmet-async';
import { ExperienceItem } from '@/hooks/profile';
import { ProfileData } from '@/hooks/useProfiles';
import { calculateDuration } from '@/utils/durationCalculator';

interface ExperienceStructuredDataProps {
  profile: ProfileData;
  experienceItems: ExperienceItem[];
}

const ExperienceStructuredData: React.FC<ExperienceStructuredDataProps> = ({ 
  profile, 
  experienceItems 
}) => {
  if (!experienceItems.length) return null;
  
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Person",
    "name": profile.display_name || profile.username || "",
    "workExperience": experienceItems.map((item) => {
      const duration = calculateDuration(item.start_date, item.end_date, item.current || false);
      
      return {
        "@type": "OrganizationRole",
        "roleName": item.position,
        "worksFor": {
          "@type": "Organization",
          "name": item.company
        },
        "startDate": item.start_date,
        "endDate": item.current ? null : item.end_date,
        "description": item.description,
        // Add duration as additional property for better SEO
        "additionalProperty": {
          "@type": "PropertyValue",
          "name": "duration",
          "value": duration
        }
      };
    })
  };

  return (
    <Helmet>
      <script type="application/ld+json">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>
  );
};

export default ExperienceStructuredData;
